import {
  type LibrarySymbolRef,
  ProjectActions,
} from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { put, select } from 'redux-saga/effects'

import { LibraryNotifications } from '../notifications'
import { selectMissingLibraryRefs } from '../selectors'

/**
 * Symbols deleted from the library leave the project: whoever may write
 * commits one purge (kept out of undo), everyone else only sees the toast
 * until a writer opens the project. Runs after the library store is fresh.
 */
export function* purgeMissingSymbols() {
  const refs: LibrarySymbolRef[] = yield select(selectMissingLibraryRefs)

  if (refs.length === 0) {
    return
  }

  yield put(LibraryNotifications.purged(refs.length))

  const canEdit: boolean = yield select(
    (state: AppState) => state.manager.meta.access.canEdit
  )

  if (!canEdit) {
    return
  }

  const purge = ProjectActions.symbols.purge({
    ids: refs.map(({ id }) => id),
    blockIds: refs.flatMap(({ dependents }) => dependents),
  })

  yield put({ ...commitProjectRequest(purge), history: false })
}
